import { AsyncDropdown } from "src/app/models/async-dropdown";

export class Product {
    identifier: string;
    quantity: number;
    product: AsyncDropdown;
  }
